/* eslint-disable react/prop-types */
import * as React from 'react';

export const Forward = ({ ...props }: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width={24} height={24} aria-label="Same Tab" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Same Tab</title>
    <path d="m10 16.9 5.5-5.4L10 6.1" stroke={props.stroke || 'currentColor'} fill="none" />
  </svg>
);
